<header mat-dialog-title>
  <h1 class="mb-15 c-primary">Tutorial videos</h1>
  <button mat-dialog-close class="btn icon-close"></button>
</header>

<div mat-dialog-content class="mb-25">
  <app-video-gallery></app-video-gallery>
</div>

